@if(legalTerms?.ltm_notification_mode === LegalTermsNotificationMode.INFORMATIVE) {
<div class="content">
    <p class="fs-5">
        We have updated our Terms of Use, please review them <a [href]="termsOfUseUrl" target="_blank">here</a>
    </p>
</div>
} @else {
<h2 class="fw-bold mb-4">Legal Terms</h2>

<div>

    <div class="content">

        <h4 class="pb-2 date fw-semibold">As of {{applicableDate}}, our terms have
            changed</h4>

        <p class="fs-5">
            To continue using SprintPass, you must accept the new <a [href]="termsOfUseUrl" target="_blank">Terms of
                Use</a>
            and <a [href]="privacyPolicyUrl" target="_blank">Privacy Policy</a>
        </p>

        <p class="fs-5">
            By accepting, you acknowledge you've read them and agree to these updates.
        </p>

        <div class="pt-1" *ngIf="isMandatory">
            <div class="alert alert-warning fs-6" role="alert">
                <span class="material-icons-outlined align-middle">
                    warning
                </span>
                Accept the legal terms to be able to continue using the platform
            </div>
        </div>

    </div>

    <div class="d-flex flex-row-reverse justify-content-center mt-4">
        <button type="button" class="btn btn-primary ms-3" [class.loading]="saving" [disabled]="saving"
            (click)="accept()">
            Accept
        </button>
        <button type="button" class="btn" [disabled]="saving" (click)="cancel()">
            {{cancelLabel}}
        </button>
    </div>

</div>
}